import { computed, autorun, observable, toJS } from 'mobx';

export default class MonitoringModel {
  id;
  station_identifier;
  station_name;

  store;

  constructor(store, monitoring) {
    this.store = store;
    // QC Check
    this.id = +monitoring.id; // Station ID
    this.description = monitoring.description; // Error Message (qc_check.description)
    this.time = monitoring.time; // qc_check.time
    // Station
    this.station_id = +monitoring.station_id;
    this.station_identifier = monitoring.station_identifier;
    this.station_name = monitoring.station_name;
    this.data_series = monitoring.data_series;
    this.count = monitoring.count;
    this.error_message = monitoring.error_message;
  }

  @computed get asJson() {
    return {
      id: +this.id,
      description: this.description,
      time: this.time,
      station_id: +this.station_id,
      station_identifier: this.station_identifier,
      station_name: this.station_name,
      data_series: this.data_series,
      count: this.count,
      error_message: this.error_message,
    };
  }

  updateFromJson(json, field) {
    // if field is specified, update only that field and return. Unstable
    if (field) {
      this[field] = json || [];
      return;
    }

    this.id = +json.id;
    this.description = json.description;
    this.time = json.time;
    this.station_id = +json.station_id;
    this.station_identifier = json.station_identifier;
    this.station_name = json.station_name;
    this.data_series = json.data_series;
    this.count = json.count;
    this.error_message = json.error_message;
  }
}



// WEBPACK FOOTER //
// ./src/models/MonitoringModel.js